import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/notices.vue'
wx.createPage(MiniProgramPage)